<template>
  <button v-if="!showFilter" @click="toggleFilter" class="btn btn-outline-success mr-2" :class="notClassPull ? '' : 'pull-right'">
    <i class="ti-search"></i>
  </button>

  <button v-else @click="$emit('toggle-filter')" class="btn btn-outline-danger mr-2" :class="notClassPull ? '' : 'pull-right'">
    <i class="fa fa-times"></i>
  </button>
</template>

<script>
export default {
  components: {},
  props: {
    showFilter: {
      type: Boolean,
      default: false
    },
    notClassPull: {
      type: Boolean,
      default: false
    }
    // filters : {
    //   type : Object,
    //   default: {}
    // }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {

  },
  methods: {
    toggleFilter() {
      this.$emit('toggle-filter')
    }
  },
  watch: {},
}
</script>




